import { Box } from '@mui/material';
import { Outlet, useNavigate, useOutletContext } from 'react-router';
import { useEffect, useState } from 'react';
import { ConsentCenterUserInfo } from './props-types';
import i18n from 'i18n';

const ConsentPreferenceBase = (): JSX.Element => {
  const [consentUserInfo, setConsentUserInfo] = useState<ConsentCenterUserInfo>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const currentLanguage = i18n.resolvedLanguage;
  const navigate = useNavigate();

  const identifier = queryParameters.get('identifier');
  const email = queryParameters.get('email');
  const phoneNumber = queryParameters.get('phone');

  useEffect(() => {
    setIsLoading(true);
    if (identifier == null || (!email && !phoneNumber) || (phoneNumber && phoneNumber?.length != 10)) {
      navigate(`/${currentLanguage}/NotFound`);
    } else {
      setConsentUserInfo({
        Identifier: identifier ?? '',
        Email: email,
        Phone: phoneNumber,
      });
    }
  }, [currentLanguage, email, identifier, navigate, phoneNumber]);

  return (
    <Box
      sx={{
        minHeight: '75vh',
        width: { xs: 'none', md: 640 },
        margin: { xs: '0 auto' },
        padding: { xs: '16px', sm: '24px' },
      }}>
      {consentUserInfo && <Outlet context={{ consentUserInfo, setConsentUserInfo, isLoading, setIsLoading }} />}
    </Box>
  );
};

export const useLoading = (): {
  isLoading: boolean;
  setIsLoading: (value: boolean | ((prevVar: boolean) => boolean)) => void;
} => {
  return useOutletContext<{
    isLoading: boolean;
    setIsLoading: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  }>();
};

export const useConsentUserInfo = (): {
  consentUserInfo: ConsentCenterUserInfo;
  setConsentUserInfo: (
    value: ConsentCenterUserInfo | ((prevVar: ConsentCenterUserInfo) => ConsentCenterUserInfo)
  ) => void;
} => {
  return useOutletContext<{
    consentUserInfo: ConsentCenterUserInfo;
    setConsentUserInfo: (
      value: ConsentCenterUserInfo | ((prevVar: ConsentCenterUserInfo) => ConsentCenterUserInfo)
    ) => void;
  }>();
};

export default ConsentPreferenceBase;
